<div
	class="example-element-detail"
	[@detailExpand]="entity === expandedEntity ? 'expanded' : 'collapsed'"
	(click)="handleRowExpansionClick ? handleRowExpansionClick(entity) : undefined"
	[ngStyle]="{ cursor: handleRowExpansionClick ? 'pointer' : 'cursor', width: '100%' }"
>
	<div [ngStyle]="{ width: '100%' }" [innerHTML]="rowExpansionHtml"></div>
</div>
